import { useState } from "react";
import Features from "./Features";
import Speficication from "./Speficication";
import CareInstruction from "./CareInstruction";
import SizeGuide from "./SizeGuide";
import MagicContent from "./MagicContent";

function ProductTab({ productDetails }) {
  const [activeTab, setActiveTab] = useState("highlights");

  if (!["carpet", "runner"].includes(productDetails?.sub_category_action_url)) {
    return null;
  }

  const specifications =
    productDetails?.product_other_info?.[0]?.specifications ?? [];

  const features =
    productDetails?.product_other_info?.[0]?.features ?? [];

  const careInstructions =
    productDetails?.product_other_info?.[0]?.care_instructions ?? "";

  const sizeGuide =
    productDetails?.product_other_info?.[0]?.size_guide ?? [];

  return (
    <>
      <div className="product-tabs-container">
        <div className="tabs-bar">
          <button
            type="button"
            className={`tab-btn-pdp ${activeTab === "highlights" ? "active" : ""}`}
            onClick={() => setActiveTab("highlights")}
          >
            Highlights
          </button>

          <button
            type="button"
            className={`tab-btn-pdp ${activeTab === "care" ? "active" : ""}`}
            onClick={() => setActiveTab("care")}
          >
            Care
          </button>

          <button
            type="button"
            className={`tab-btn-pdp ${activeTab === "size-guide" ? "active" : ""}`}
            onClick={() => setActiveTab("size-guide")}
          >
            Size Guide
          </button>
        </div>

        <div className="track_box_pr">
          <div className="img_section">
            <img
              src={productDetails?.product_images?.[1]?.media}
              alt="Product"
              className="highlight-image"
            />
          </div>

          <div>
            {activeTab === "highlights" && (
              <div className="tab-section">
                <Speficication speficicationData={specifications} />
                <Features featureData={features} />
              </div>
            )}

            {activeTab === "care" && (
              <div className="tab-section">
                <CareInstruction CareInstructionItem={careInstructions} />
              </div>
            )}

            {activeTab === "size-guide" && (
              <div className="tab-section">
                <SizeGuide size_guideData={sizeGuide} />
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="rec_section">
        <div className="recommend-good-know">
          <div className="recommend-section">
            <h4>RECOMMENDED FOR</h4>
            <ul>
              <li>Calm, cozy bedrooms or serene living spaces</li>
              <li>Soft underfoot comfort in nurseries or reading nooks</li>
              <li>Homes with a neutral, pastel, or coastal-inspired palette</li>
              <li>Anyone looking to add quiet elegance to their space</li>
            </ul>
          </div>

          <div className="center-image">
            <img
              src={productDetails?.product_images?.[2]?.media}
              alt="Room setting"
            />
          </div>

          <div className="good-to-know-section">
            <h4>GOOD TO KNOW</h4>
            <ul className="custom-tick-list">
              <li>Edges may curl initially; lay flat or reverse-roll to settle</li>
              <li>Color may look different under various lighting</li>
              <li>Not recommended for damp areas like bathrooms</li>
            </ul>
          </div>

          <MagicContent />
        </div>
      </div>
    </>
  );
}

export default ProductTab;